var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGridiconsUser2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99566 2.23633C8.76011 2.23633 9.49325 2.54 10.0338 3.08055C10.5743 3.6211 10.878 4.35423 10.878 5.11868C10.878 5.88313 10.5743 6.61627 10.0338 7.15681C9.49325 7.69736 8.76011 8.00103 7.99566 8.00103C7.23121 8.00103 6.49808 7.69736 5.95753 7.15681C5.41698 6.61627 5.11331 5.88313 5.11331 5.11868C5.11331 4.35423 5.41698 3.6211 5.95753 3.08055C6.49808 2.54 7.23121 2.23633 7.99566 2.23633ZM7.99566 13.7657C7.99566 13.7657 13.7604 13.7657 13.7604 12.3246C13.7604 10.5951 10.9501 8.72162 7.99566 8.72162C5.04125 8.72162 2.23096 10.5951 2.23096 12.3246C2.23096 13.7657 7.99566 13.7657 7.99566 13.7657Z",
    fill: "#253837"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridiconsUser2);
export default __webpack_public_path__ + "static/media/gridicons_user2.a5acda2ecaba4653426557f4eff397f7.svg";
export { ForwardRef as ReactComponent };